<arm-layout [summaryTitle]="'SERVER SUMMARY'">
  <div header>
    <div class="search-container">
      <client-filter (onFilter)="onFilter($event)"></client-filter>
    </div>
    <div class="action-buttons">

      <button [disabled]="isUnauthorized" mat-icon-button matTooltip="Add">
        <mat-icon  [svgIcon]="isUnauthorized ? 'add_disabled' : 'add'"
                   class="icon-display" [matMenuTriggerFor]="addMenu"></mat-icon>
      </button>

      <mat-menu #addMenu="matMenu">
        <button (click)="addItem('LDAP')" mat-menu-item [disabled]="isUnauthorized">
          <span>LDAP server</span>
        </button>
        <button (click)="addItem('AZURE')" mat-menu-item [disabled]="isUnauthorized">
          <span>Azure AD</span>
        </button>
        <button (click)="addItem('UMP')" mat-menu-item [disabled]="isUnauthorized">
          <span>UMP</span>
        </button>
      </mat-menu>

      <button (click)="editItem()" [disabled]="isUnauthorized || !selection" mat-icon-button matTooltip="Edit">
        <mat-icon  [svgIcon]="isUnauthorized || !selection ? 'edit_disabled' : 'edit'"
                   class="icon-display"></mat-icon>
      </button>

      <button (click)="removeItem()" [disabled]="isUnauthorized || !selection" mat-icon-button matTooltip="Delete">
        <mat-icon  [svgIcon]="isUnauthorized || !selection ? 'delete_disabled' : 'delete'"
                   class="icon-display"></mat-icon>
      </button>

      <button mat-icon-button matTooltip="Refresh">
        <mat-icon (click)="refresh()" class="icon-display" svgIcon="refresh"></mat-icon>
      </button>

      <button [matMenuTriggerFor]="menu" class="more-actions" color="primary" mat-raised-button>
        <span>Actions</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button (click)="openColumnsConfiguration()" mat-menu-item>
          <span>Table columns</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div summary>
    <servers-summary [selection]="selection" [normalizationGroups]="normalizationGroupsOptions">
    </servers-summary>
  </div>

  <div main>
    <arm-table [data]="data" (onSelection)="select($event)"
               [displayedColumns]="displayedColumns" [isMultipleSelection]="false"
               [isClientSide]="true" [filter]="filter"></arm-table>
  </div>
</arm-layout>
